/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Faq_Q3_AnswerInputs */

const en_faq_q3_answer = /** @type {(inputs: Faq_Q3_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yes! Your ${i?.companyName} insurance gives you worldwide coverage, but you must spend at least 51% of the time your policy is in effect in Canada. The only place you are not covered is your home country, with possible travel restrictions to high-risk countries.`)
};

const fr_faq_q3_answer = /** @type {(inputs: Faq_Q3_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oui ! Votre assurance ${i?.companyName} vous offre une couverture mondiale, mais vous devez passer au moins 51 % de la durée de votre police au Canada. Le seul endroit où vous n'êtes pas couvert est votre pays d'origine, avec d'éventuelles restrictions de voyage vers les pays à risque élevé.`)
};

/**
* | output |
* | --- |
* | "Yes! Your {companyName} insurance gives you worldwide coverage, but you must spend at least 51% of the time your policy is in effect in Canada. The only plac..." |
*
* @param {Faq_Q3_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q3_answer = /** @type {((inputs: Faq_Q3_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q3_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q3_answer(inputs)
	return fr_faq_q3_answer(inputs)
});